<template>
   <div class="package-iframe-c">
      <!-- {{ $t("common_schmetterlingPopupInformationMsg") }}
      <br />
      <br />
      <UIButton className="default" :text="$t('common_btnSchmetterlingPopup')" @click.native="handlerOpenPopup(IframeUrl)" /> -->

      <template v-if="iframeInformations?.status">
         <iframe :src="IframeUrl" title="Schimetterling Login" class="iframe-sc" @load="hidePreloader" width="100%" height="100%"> </iframe>
      </template>
   </div>
</template>

<script>
// import UIButton from "@/components/unitary/Button.vue";
export default {
   name: "PackageIframe",
   props: {
      iframeInformations: Object,
   },
   components: {
      // UIButton,
   },
   data() {
      return {
         showIframe: false,
      };
   },
   mounted() {
      this.$nextTick(() => {
         if (this.iframeInformations?.status) {
            const input = document.querySelector("iframe").contentDocument.querySelector("input");
            input.addEventListener("focus", (event) => {
               event.preventDefault();
               input.scrollIntoView({ block: "nearest", behavior: "smooth" });
            });
         }
      });
   },

   computed: {
      IframeUrl() {
         let baseUrl = "https://proxy.schmetterling-argus.de/webstart/v1/gts/";

         switch (this.iframeInformations.application) {
            case 1:
               return `${baseUrl}xena/${this.iframeInformations.agencyCode}_${this.iframeInformations.userId}/${this.iframeInformations.hash}?lang=${this.iframeInformations.lang}`;
            case 2:
               return `${baseUrl}xena/${this.iframeInformations.agencyCode}_${this.iframeInformations.userId}/${this.iframeInformations.hash}?lang=${this.iframeInformations.lang}`;
            default:
               return false;
         }

         // return `${baseUrl}/${this.iframeInformations.agencyCode}/${this.iframeInformations.hash}`;
      },
   },
   methods: {
      hidePreloader() {
         setTimeout(() => {
            this.$store.commit("app/setIsProgressGifActive", false);
         }, 1000);
      },
      handlerOpenPopup(newUrl) {
         try {
            const popup = window.open(newUrl, "minimal-popup", `width=${screen.width},height=${screen.height},left=0,top=0,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`);

            if (!popup) {
               console.warn("Popup tarayıcı tarafından engellendi");
            }
         } catch (error) {
            console.error("Popup açılırken hata:", error);
         }
         this.hidePreloader();
      },
   },
   // watch: {
   //    IframeUrl: {
   //       handler: function (newUrl, oldUrl) {
   //          let pathControl = this.$route.query.p;
   //          if (pathControl == "true") {
   //             this.showIframe = true;
   //             return;
   //          }

   //          // Sadece URL gerçekten değiştiğinde ve ilk yüklemede değilse aç
   //          if (newUrl && newUrl !== oldUrl && oldUrl !== undefined) {
   //             this.handlerOpenPopup(newUrl);
   //          }
   //       },
   //    },
   // },
};
</script>

<style lang="scss">
iframe {
   overflow: hidden;
   height: 100vh;
}
</style>

<style lang="scss" scoped>
.package-iframe-c {
   padding: 1rem;
   // width: 100%;
   // height: 100%;
   // // border: 1px solid;

   // iframe {
   //    width: 100%;
   //    height: 100%;
   // }
}
</style>
